if (!customElements.get('bioluma-reviews-carousel')) {
  customElements.define(
    'bioluma-reviews-carousel',
    class BiolumaReviewsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.track = this.querySelector('[data-reviews-track]');
        this.slides = Array.from(this.querySelectorAll('[data-reviews-slide]'));
        this.dotsWrap = this.querySelector('[data-reviews-dots]');
        this.prevBtn = this.querySelector('[data-reviews-prev]');
        this.nextBtn = this.querySelector('[data-reviews-next]');
        this.page = 0;

        this.onPrev = (event) => {
          event.preventDefault();
          this.goTo(this.page - 1);
        };
        this.onNext = (event) => {
          event.preventDefault();
          this.goTo(this.page + 1);
        };
        this.onResize = () => {
          const pages = this.pageCount();
          if (this.page > pages - 1) this.page = Math.max(0, pages - 1);
          this.renderDots();
          this.apply();
        };

        this.prevBtn?.addEventListener('click', this.onPrev);
        this.nextBtn?.addEventListener('click', this.onNext);
        window.addEventListener('resize', this.onResize);
        this.bindSwipe();
        this.renderDots();
        this.apply();
      }

      disconnectedCallback() {
        this.prevBtn?.removeEventListener('click', this.onPrev);
        this.nextBtn?.removeEventListener('click', this.onNext);
        window.removeEventListener('resize', this.onResize);
        this.unbindSwipe();
        this.bound = false;
      }

      perPage() {
        const host = this.closest('.bioluma-reviews') || this;
        const raw = getComputedStyle(host).getPropertyValue('--brv-visible').trim();
        const value = Number(raw);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      pageCount() {
        return Math.max(1, Math.ceil(this.slides.length / Math.floor(this.perPage())));
      }

      goTo(next) {
        const pages = this.pageCount();
        this.page = Math.max(0, Math.min(next, pages - 1));
        this.apply();
      }

      updateNav() {
        const pages = this.pageCount();
        const atStart = this.page <= 0;
        const atEnd = this.page >= pages - 1;

        if (this.prevBtn) {
          this.prevBtn.disabled = atStart;
          this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }

        if (this.nextBtn) {
          this.nextBtn.disabled = atEnd;
          this.nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }

      apply() {
        if (!this.track || !this.slides.length) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const step = Math.floor(this.perPage());
        const offset = this.page * step * (slideWidth + gap);
        this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;

        this.querySelectorAll('.bioluma-reviews__dot').forEach((dot, index) => {
          const active = index === this.page;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.updateNav();
      }

      renderDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        const pages = this.pageCount();

        if (pages < 2) {
          this.dotsWrap.hidden = true;
          return;
        }

        this.dotsWrap.hidden = false;
        for (let i = 0; i < pages; i += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `bioluma-reviews__dot${i === this.page ? ' is-active' : ''}`;
          button.setAttribute('aria-label', `Página ${i + 1} de ${pages}`);
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.goTo(i);
          });
          this.dotsWrap.appendChild(button);
        }
      }

      bindSwipe() {
        this.pointer = { startX: 0, delta: 0, active: false };
        this.onPointerDown = (event) => {
          this.pointer.active = true;
          this.pointer.startX = event.clientX || 0;
          this.pointer.delta = 0;
        };
        this.onPointerMove = (event) => {
          if (!this.pointer.active) return;
          this.pointer.delta = (event.clientX || 0) - this.pointer.startX;
        };
        this.onPointerUp = () => {
          if (!this.pointer.active) return;
          this.pointer.active = false;
          const pages = this.pageCount();
          if (this.pointer.delta < -50 && this.page < pages - 1) this.goTo(this.page + 1);
          if (this.pointer.delta > 50 && this.page > 0) this.goTo(this.page - 1);
        };
        this.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
      }

      unbindSwipe() {
        this.removeEventListener('pointerdown', this.onPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }
    }
  );
}
